import { isSameDay, OwaDate, owaDate, startOfDay, now } from 'owa-datetime';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import updateRecurrenceEnd from './updateRecurrenceEnd';
import { DefaultPalette } from '@fluentui/style-utilities/lib';
import type { IButtonStyles } from '@fluentui/react/lib/Button';

export function updateRecurrenceEndUtil(
    newEnd: OwaDate,
    recurrence: RecurrenceType,
    onEndRecurrenceChangedCallback: (recurrence: RecurrenceType) => void
) {
    const start = owaDate(newEnd, recurrence.RecurrenceRange.StartDate);
    let startDate = startOfDay(start);
    let todayButtonClicked = isSameDay(startOfDay(newEnd), startOfDay(now()));

    //If Today button is clicked and startDate is after Today
    if (todayButtonClicked && startDate > newEnd) {
        newEnd = startDate;
    }

    if (startDate <= newEnd) {
        onEndRecurrenceChangedCallback(updateRecurrenceEnd(recurrence, newEnd));
    }
}

export function getButtonStyle(): IButtonStyles {
    return {
        root: {
            color: DefaultPalette.themePrimary,
        },

        rootHovered: {
            color: DefaultPalette.themeDarker,
        },

        rootPressed: {
            color: DefaultPalette.themePrimary,
        },

        rootFocused: {
            color: DefaultPalette.themePrimary,
            border: 'solid 1px ' + DefaultPalette.neutralSecondary,
        },
    } as IButtonStyles;
}
